import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  MenuItem, SelectField, RaisedButton, Card, CardText,
  DatePicker, TextField
} from "material-ui";
import DateIcon from "material-ui/svg-icons/action/date-range";
import {
  BuscarSolicitudes, Loading, CambiarTipoSolicitud, CambiarEstadoSolicitud,
  CambiarIdSolicitud,
  CambiarFechaSolicitudDesde,
  CambiarFechaSolicitudHasta
} from "./actions";
import customDateTimeFormat from "../../../helpers/dateFormat";
import GrillaSolicitudes from "../GrillaSolicitudes/view";
import ErrorSnack from "../../ErrorSnack/view";
import { ObtenerEstadosSolicitud, ObtenerTiposSolicitud } from "../../Global/actions";
import banmedicaTheme from "./../../../config/banmedicaTheme";
import styles from "../../styles/styles";

class FiltroBusquedaSR extends React.Component {
  componentWillMount() {
    this.props.dispatch(ObtenerEstadosSolicitud());
    this.props.dispatch(ObtenerTiposSolicitud());
  }

  CambiarTipoSolicitud = (event, index, value) => {
    this.props.dispatch(CambiarTipoSolicitud(value));
  }

  CambiarEstadoSolicitud = (event, index, value) => {
    this.props.dispatch(CambiarEstadoSolicitud(value));
  }

  CambiarFechaSolicitudDesde = (event, date) => {
    const fechaSolicitudHastaAux = this.props.filtros.fechaSolicitudHasta;
    if (fechaSolicitudHastaAux && date) {
      date.setHours(0, 0, 0, 0);
      fechaSolicitudHastaAux.setHours(0, 0, 0, 0);
      if (fechaSolicitudHastaAux < date) {
        this.props.dispatch(CambiarFechaSolicitudDesde(
          fechaSolicitudHastaAux,
          `La fecha no puede ser mayor a ${fechaSolicitudHastaAux.toLocaleDateString()}`
        ));

        return;
      }
    }

    this.props.dispatch(CambiarFechaSolicitudDesde(date));
  }

  CambiarFechaSolicitudHasta = (event, date) => {
    const fechaSolicitudDesdeAux = this.props.filtros.fechaSolicitudDesde;
    if (fechaSolicitudDesdeAux && date) {
      date.setHours(0, 0, 0, 0);
      fechaSolicitudDesdeAux.setHours(0, 0, 0, 0);
      if (fechaSolicitudDesdeAux > date) {
        this.props.dispatch(CambiarFechaSolicitudHasta(
          fechaSolicitudDesdeAux,
          `La fecha no puede ser menor a ${fechaSolicitudDesdeAux.toLocaleDateString()}`
        ));

        return;
      }
    }

    this.props.dispatch(CambiarFechaSolicitudHasta(date));
  }

  CambiarIdSolicitud = (event) => {
    const re = /^[0-9]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.props.dispatch(CambiarIdSolicitud(event.target.value));
    }
  }

  BuscarSolicitudes = () => {
    this.props.dispatch(Loading(true));
    this.props.dispatch(BuscarSolicitudes());
  }

  render() {
    const menuListTiposSolicitud = [];
    if (this.props.tiposSolicitud) {
      menuListTiposSolicitud.push(<MenuItem key={0} value={0} primaryText="Todas" />);
      this.props.tiposSolicitud.forEach((element) => {
        menuListTiposSolicitud.push(<MenuItem key={element.Id} value={element.Id} primaryText={element.Nombre} />);
      });
    }

    const menuListEstadosSolicitud = [];
    if (this.props.estadosSolicitud) {
      menuListEstadosSolicitud.push(<MenuItem key={0} value={0} primaryText="Todas" />);
      this.props.estadosSolicitud.forEach((element) => {
        if (element.Id !== 6) { // En edición
          menuListEstadosSolicitud.push(<MenuItem key={element.Id} value={element.Id} primaryText={element.Nombre} />);
        }
      });
    }

    return (
      <div>

        {this.props.token ?

          <div>
            <div style={styles.frameContenidoGeneral}>
              <Card zDepth={0} style={{ paddingBottom: 0 }}>
                <CardText style={{ paddingBottom: 0 }}>
                  <div className="row" style={{ paddingBottom: 0 }}>
                    <div className="contenido" style={{ margin: 0, padding: 0, width: 925 }}>
                      <div style={styles.h1}>Solicitudes enviadas a la Isapre
                      </div>
                      <div style={styles.h2}>
                        Seleccione el tipo y el estado de la solicitud que desea consultar.<br />
                        Además puede adicionar a la busqueda el filtro por fecha de solicitud.
                      </div>
                      <div style={styles.h3}>Rut Institución: {this.props.rutInstitucion}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4" style={styles.colSelectFieldActualizar}>
                      <div style={styles.floatingClaseSelect}> Tipo de Solicitud </div>
                      <SelectField
                        name="dd_fbsr_tiposolicitud"
                        id="dd_fbsr_tiposolicitud"
                        value={this.props.filtros.tipoSolicitud}
                        onChange={this.CambiarTipoSolicitud}
                        labelStyle={styles.h4}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.selectFiledStyle}
                        iconStyle={styles.iconSelectField}
                        menuItemStyle={styles.menuItemStyleSelectField}
                        selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                      >
                        {menuListTiposSolicitud}
                      </SelectField>
                    </div>
                    <div className="col-4" style={styles.colSelectFieldActualizar}>
                      <div style={styles.floatingClaseSelect}> Estado de Solicitud </div>
                      <SelectField
                        name="dd_fbsr_estadosolicitud"
                        id="dd_fbsr_estadosolicitud"
                        value={this.props.filtros.estadoSolicitud}
                        onChange={this.CambiarEstadoSolicitud}
                        labelStyle={styles.h4}
                        underlineStyle={styles.underlineSelectField}
                        style={styles.selectFiledStyle}
                        iconStyle={styles.iconSelectField}
                        menuItemStyle={styles.menuItemStyleSelectField}
                        selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                      >
                        {menuListEstadosSolicitud}
                      </SelectField>
                    </div>
                    <div className="col-4" style={styles.colSelectFieldActualizar}>
                      <div style={styles.floatingClaseSelect}> Id de Solicitud </div>
                      <TextField
                        name="txt_fbsr_idsolicitud"
                        id="txt_fbsr_idsolicitud"
                        value={this.props.filtros.idSolicitud || ""}
                        errorText={this.props.filtros.idSolicitudError || ""}
                        onChange={this.CambiarIdSolicitud}
                        maxLength={10}
                        underlineStyle={styles.underlineSelectField}
                        inputStyle={styles.h4}
                        style={styles.selectFiledStyle}
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-4" style={styles.colSelectFieldActualizar}>
                      <div style={styles.floatingClaseSelect}> Fecha Solicitud desde </div>
                      <div className="container">
                        <div className="row" >
                          <DatePicker
                            name="dd_fbsr_fechasolicituddesde"
                            id="dd_fbsr_fechasolicituddesde"
                            mode="landscape"
                            DateTimeFormat={customDateTimeFormat.cl()}
                            locale="es-CL"
                            firstDayOfWeek={1}
                            value={this.props.filtros.fechaSolicitudDesde}
                            errorText={this.props.filtros.fechaSolicitudDesdeError}
                            onDismiss={() => this.CambiarFechaSolicitudDesde(null)}
                            onChange={this.CambiarFechaSolicitudDesde}
                            underlineStyle={styles.underlineSelectField}
                            style={styles.datepickerStyle}
                            inputStyle={styles.h4}
                          />
                          <DateIcon
                            style={{ marginTop: 3, marginLeft: 5 }}
                            color={banmedicaTheme.palette.accent1Color}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-4" style={styles.colSelectFieldActualizar}>
                      <div style={styles.floatingClaseSelect}> Fecha Solicitud hasta </div>
                      <div className="container">
                        <div className="row" >
                          <DatePicker
                            name="dd_fbsr_fechasolicitudhasta"
                            id="dd_fbsr_fechasolicitudhasta"
                            mode="landscape"
                            DateTimeFormat={customDateTimeFormat.cl()}
                            locale="es-CL"
                            firstDayOfWeek={1}
                            value={this.props.filtros.fechaSolicitudHasta}
                            errorText={this.props.filtros.fechaSolicitudHastaError}
                            onDismiss={() => this.CambiarFechaSolicitudHasta(null)}
                            onChange={this.CambiarFechaSolicitudHasta}
                            underlineStyle={styles.underlineSelectField}
                            style={styles.datepickerStyle}
                            inputStyle={styles.h4}
                          />
                          <DateIcon
                            style={{ marginTop: 3, marginLeft: 5 }}
                            color={banmedicaTheme.palette.accent1Color}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-4" style={{ paddingTop: 30 }}>
                      {!this.props.loading ?
                        <RaisedButton
                          label="Buscar"
                          onClick={this.BuscarSolicitudes}
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                        :
                        <RaisedButton
                          label="Cargando ..."
                          secondary
                          labelStyle={{ fontSize: "11px" }}
                          overlayStyle={{ borderRadius: 5 }}
                          rippleStyle={{ borderRadius: 5 }}
                          style={{ width: "130px", borderRadius: 5, marginLeft: 20 }}
                          buttonStyle={{ borderRadius: 5 }}
                        />
                      }
                    </div>
                  </div>
                </CardText>
              </Card>
            </div>

            <GrillaSolicitudes />

            <ErrorSnack />
          </div>
          :
          null}
      </div>

    );
  }
}

FiltroBusquedaSR.propTypes = {
  loading: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  tiposSolicitud: PropTypes.array.isRequired,
  estadosSolicitud: PropTypes.array.isRequired,
  filtros: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
  token: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.filtroBusquedaSR.loading,
  rutInstitucion: state.global.rutInstitucion,
  isapre: state.global.isapre,
  tiposSolicitud: state.global.tiposSolicitud,
  estadosSolicitud: state.global.estadosSolicitud,
  filtros: state.filtroBusquedaSR.filtros,
  token: state.global.token,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaSR);

